// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-" + {"vendors-node_modules_react_jsx-runtime_js":"6dbbc1bf447c5add0260","src_bootstrap_tsx":"84453b62cd06d1affc8a"}[chunkId] + ".js";
};